import syncSettingsWithDevEditor from '../../settings/syncSettingsWithDevEditor';

function initTPAViewModeDevEditor(tpaParams, settingsStore) {
  // TODO: load initial settings from dev editor
  syncSettingsWithDevEditor(settingsStore);
}

export default initTPAViewModeDevEditor;
